import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from '@/router'
import { createHead } from '@unhead/vue'
import { VueQueryPlugin, VueQueryPluginOptions } from '@tanstack/vue-query'
import Notifications from '@kyvg/vue3-notification'
import { AuthService, AuthServicePlugin } from './services/AuthService'
import App from '@/App.vue'
import FirebaseService from './services/FirebaseService'
import { onAuthStateChanged } from 'firebase/auth'
import '@/assets/styles/app-styles.scss'

const pinia = createPinia()
const app = createApp(App)
const authService = new AuthService()

app.use(AuthServicePlugin, { authService })
app.use(pinia)
app.use(router)
app.use(Notifications)
app.use(createHead())

const route = router.currentRoute.value
const { authorize } = route.meta

const cacheStaleTime = process.env.NODE_ENV === 'production' ? 1000 * 60 * 60 : 1000 * 60 * 5
const vueQueryOptions: VueQueryPluginOptions = {
  enableDevtoolsV6Plugin: true,
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: cacheStaleTime
      }
    }
  }
}
app.use(VueQueryPlugin, vueQueryOptions)

FirebaseService.auth().then(auth => {
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      const redirectPath = router.currentRoute.value.query.redirect as string
      const toPath = router.currentRoute.value.fullPath
      let path = '/'

      if (redirectPath) {
        path = redirectPath
      } else if (toPath !== '/login' && toPath !== '/signup') {
        path = toPath
      }

      await authService.syncProfile(user)
      router.push(path)
    } else if (!user) {
      if (authorize) {
        await authService.logout()
        router.push('/login')
      }
    }
  })
}).finally(() => {
  app.mount('#app')
})
